import {fetchWrapper} from "../Helpers/fetchWrapper";
import { apiService } from './apiService';

const contactus = (data) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/contactus`, data);
};

const validateContactUs = (data) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/contactus/validate`, data);
};

const getCesiumToken = () => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/token/cesium`);
};

export const siteService = {
    domainConfig,
    contactus,
    validateContactUs,
    getCesiumToken
};

function domainConfig(region, domain) {
    return fetchWrapper.get(`${apiService.getApiBaseUrl(region)}/domain-based-configuration?domain=${domain}`);
}

// function contactus(captcha, contactUsData) {
//     const url = window.location.protocol + '//' + window.location.host + "/contactus";
//     let requestOptions = {
//         method: 'POST',
//         body: contactUsData,
//         headers: {'Content-Type': 'text/html', captcha: captcha},        
//     };
//     return fetch(url, requestOptions).then(handleResponse);
// }

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}